export const PAGE_TO_PATH: Record<string, string> = {
  dashboard: '/dashboard',
  gst: '/gst',
  inventory: '/inventory',
  factory: '/factory',
  orders: '/orders',
  workforce: '/workforce',
  assets: '/assets',
  finance: '/finance',
  reports: '/reports',
  quality: '/factory?tab=quality_checks',
  approvals: '/approvals',
  notifications: '/notifications',
  profile: '/profile',
  settings: '/settings',
  help: '/help',
  login: '/login',
  signup: '/signup',
};

export const PATH_TO_PAGE: Record<string, string> = Object.fromEntries(
  Object.entries(PAGE_TO_PATH).map(([page, path]) => [path, page]),
);
